import React from 'react';
import { Panel } from 'components'

const PanelWidget = ({ children, ...otherProps  }) => {
    return <Panel {...otherProps}>{ children }</Panel>
}


export default PanelWidget;